import React, { lazy, Suspense, useState, useEffect, ReactComponentElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import SVG, { Props as SVGProps } from 'react-inlinesvg';
import { ReactComponent as Add } from '../../../Icon/Add.svg';
import { ReactComponent as Setup_Add } from '../../../Icon/Setup/Add.svg';
import { ReactComponent as Copy } from '../../../Icon/Copy.svg';
import { ReactComponent as Cut } from '../../../Icon/Cut.svg';
import { ReactComponent as Delete } from '../../../Icon/Delete.svg';
import { ReactComponent as Edit } from '../../../Icon/Edit.svg';
import { ReactComponent as Paste } from '../../../Icon/Paste.svg';
import { ReactComponent as Print } from '../../../Icon/Print.svg';
import { ReactComponent as ThreeDotMenu } from '../../../Icon/ThreeDotMenu.svg';
import { ReactComponent as ListView } from '../../../Icon/ListView.svg';
import { ReactComponent as ContentView } from '../../../Icon/ContentView.svg';
import { ReactComponent as ThumbnailView } from '../../../Icon/ThumbnailView.svg';
import { ReactComponent as DetailView } from '../../../Icon/DetailView.svg';
import { ReactComponent as FolderOpen } from '../../../Icon/FolderOpen.svg';
import { ReactComponent as Folder } from '../../../Icon/Folder.svg';
import { ReactComponent as AccessRight } from '../../../Icon/AccessRight.svg';
import { ReactComponent as HitsReport } from '../../../Icon/HitsReport.svg';
import { ReactComponent as Marco } from '../../../Icon/Marco.svg';
import { ReactComponent as Analyze } from '../../../Icon/Analyze.svg';
import { ReactComponent as Unlock } from '../../../Icon/Unlock.svg';
import { ReactComponent as Pin } from '../../../Icon/Pin.svg';
import { ReactComponent as Info } from '../../../Icon/Info.svg';
import { ReactComponent as ArrowDown } from '../../../Icon/ArrowDown.svg';
import { ReactComponent as Setup_Ascending } from '../../../Icon/Setup/Ascending.svg';
import { ReactComponent as Setup_Descending } from '../../../Icon/Setup/Descending.svg';
import { ReactComponent as Remove } from '../../../Icon/Remove.svg';
import { ReactComponent as Setup_Remove } from '../../../Icon/Setup/Remove.svg';
import { ReactComponent as Setup_Settings } from '../../../Icon/Setup/Settings.svg';
import { ReactComponent as Setup_Refresh } from '../../../Icon/Setup/Refresh.svg';
import { ReactComponent as Setup_Globe } from '../../../Icon/Setup/Globe.svg';
import { ReactComponent as Setup_Reagents } from '../../../Icon/Setup/Reagents.svg';
import { ReactComponent as Setup_Camera } from '../../../Icon/Setup/Camera.svg';
import { ReactComponent as Setup_xtal } from '../../../Icon/Setup/xtal.svg';
import { ReactComponent as Setup_Dispense } from '../../../Icon/Setup/Dispense.svg';
import { ReactComponent as Crystals } from '../../../Icon/Crystals.svg';
import { ReactComponent as Plate } from '../../../Icon/Plate.svg';
import { ReactComponent as Setup_Plate } from '../../../Icon/Setup/Plate.svg';
import { ReactComponent as crystaltracking } from '../../../Icon/crystaltracking.svg';
import { ReactComponent as Protein } from '../../../Icon/Protein.svg';
import { ReactComponent as Seed } from '../../../Icon/Seed.svg';
import { ReactComponent as Experiment } from '../../../Icon/Experiment.svg';
import { ReactComponent as Screen } from '../../../Icon/Screen.svg';
import { ReactComponent as Project } from '../../../Icon/Project.svg';
import { ReactComponent as Projects } from '../../../Icon/Projects.svg';
import { ReactComponent as ProjectsFolder } from '../../../Icon/ProjectsFolder.svg';
import { ReactComponent as ConvertToScreen } from '../../../Icon/ConvertToScreen.svg';
import { ReactComponent as ImageNow } from '../../../Icon/ImageNow.svg';
import { ReactComponent as FragmentScreen } from '../../../Icon/FragmentScreen.svg';
import { ReactComponent as ExperimentReport } from '../../../Icon/ExperimentReport.svg';
import { ReactComponent as Dispensed } from '../../../Icon/Dispensed.svg';
import { ReactComponent as DispensedAlchemist } from '../../../Icon/DispensedAlchemist.svg';
import { ReactComponent as Export } from '../../../Icon/Export.svg';
import { ReactComponent as RotateCanvas } from '../../../Icon/RotateCanvas.svg';
import { ReactComponent as ScreenStockReport } from '../../../Icon/ScreenStockReport.svg';
import { ReactComponent as ProteinFormulation } from '../../../Icon/ProteinFormulation.svg';
import { ReactComponent as ProteinFormulation_Variants } from '../../../Icon/ProteinFormulation_Variants.svg';
import { ReactComponent as RMLogo } from '../../../Icon/RMLogo.svg';
import { ReactComponent as checkMark } from '../../../Icon/checkMark.svg';
import { ReactComponent as CrystalsGrey } from '../../../Icon/CrystalsGrey.svg';
import { ReactComponent as OrderBy } from '../../../Icon/OrderBy.svg';
import { ReactComponent as SeedAddIng } from '../../../Icon/SeedAddIng.svg';
import { ReactComponent as Tuning } from '../../../Icon/Tuning.svg';
import { ReactComponent as Images } from '../../../Icon/Images.svg';
import { ReactComponent as ScoresBottomMenu } from '../../../Icon/ScoresBottomMenu.svg';
import { ReactComponent as SeedRemoveIng } from '../../../Icon/SeedRemoveIng.svg';
import { ReactComponent as Wizard } from '../../../Icon/Wizard.svg';
import { ReactComponent as ScreenExpWizard } from '../../../Icon/ScreenExpWizard.svg';
import { ReactComponent as BatchloadExperiment } from '../../../Icon/BatchloadExperiment.svg';
import { ReactComponent as Search } from '../../../Icon/Search.svg';
import { ReactComponent as Tools } from '../../../Icon/Tools.svg';
import { ReactComponent as Email } from '../../../Icon/Email.svg';
import { ReactComponent as Close } from '../../../Icon/Close.svg';
import { ReactComponent as BatchloadTask } from '../../../Icon/BatchloadTask.svg';
import { ReactComponent as PrintBarcode } from '../../../Icon/PrintBarcode.svg';
import { ReactComponent as IngredientInfo } from '../../../Icon/IngredientInfo.svg';
import { ReactComponent as IngredientStocks } from '../../../Icon/IngredientStocks.svg';
import { ReactComponent as ImageManage } from '../../../Icon/ImageManage.svg';
import { ReactComponent as FilledArrowDown } from '../../../Icon/FilledArrowDown.svg';
import { ReactComponent as ImageNowCamera } from '../../../Icon/ImageNowCamera.svg';
import { ReactComponent as SaveImage } from '../../../Icon/SaveImage.svg';
import { ReactComponent as Tree_Experiment_Designed } from '../../../Icon/Tree/Experiment_Designed.svg';
import { ReactComponent as Tree_Experiment_Dispensed } from '../../../Icon/Tree/Experiment_Dispensed.svg';
import { ReactComponent as Tree_Experiment_Imaged } from '../../../Icon/Tree/Experiment_Imaged.svg';
import { ReactComponent as Tree_Experiment_CrystalHarvested } from '../../../Icon/Tree/Experiment_CrystalHarvested.svg';
import { ReactComponent as DashboardHeader } from '../../../Icon/DashboardHeader.svg';
import { ReactComponent as Integrated_Marco } from '../../../Icon/Integrated_Marco.svg';
import { ReactComponent as Integrated_PrintBarcode } from '../../../Icon/Integrated_PrintBarcode.svg';
import { ReactComponent as Integrated_Idle } from '../../../Icon/Integrated_Idle.svg';
import { ReactComponent as Integrated_Active } from '../../../Icon/Integrated_Active.svg';
import { ReactComponent as Integrated_Offline } from '../../../Icon/Integrated_Offline.svg';
import { ReactComponent as Integrated_Device } from '../../../Icon/Integrated_Device.svg';
import { ReactComponent as OpenTab } from '../../../Icon/OpenTab.svg';
import { ReactComponent as Pointer } from '../../../Icon/Pointer.svg';
import { ReactComponent as Bold } from '../../../Icon/Bold.svg';
import { ReactComponent as Italic } from '../../../Icon/Italic.svg';
import { ReactComponent as Underline } from '../../../Icon/Underline.svg';
import { ReactComponent as LineThrough } from '../../../Icon/LineThrough.svg';
import { ReactComponent as MoveBack } from '../../../Icon/MoveBack.svg';
import { ReactComponent as Lock } from '../../../Icon/Lock.svg';
import { ReactComponent as EditExperiment } from '../../../Icon/EditExperiment.svg';
import { ReactComponent as Barcode } from '../../../Icon/Barcode.svg';
import { ReactComponent as Reports_Report } from '../../../Icon/Reports/Report.svg';
import { ReactComponent as Reports_DesignReport } from '../../../Icon/Reports/DesignReport.svg';
import { ReactComponent as Reports_ExperimentReport } from '../../../Icon/Reports/ExperimentReport.svg';
import { ReactComponent as Reports_ImageReport } from '../../../Icon/Reports/ImageReport.svg';
import { ReactComponent as Reports_IngredientReport } from '../../../Icon/Reports/IngredientReport.svg';
import { ReactComponent as Reports_InstantDropReport } from '../../../Icon/Reports/InstantDropReport.svg';
import { ReactComponent as Reports_ScoreReport } from '../../../Icon/Reports/ScoreReport.svg';
import { ReactComponent as Reports_SingleDropReport } from '../../../Icon/Reports/SingleDropReport.svg';
import { ReactComponent as Reports_WellReport } from '../../../Icon/Reports/WellReport.svg';
import { ReactComponent as Save } from '../../../Icon/Save.svg';
import { ReactComponent as Discard } from '../../../Icon/Discard.svg';
import { ReactComponent as Layers_GridLayer } from '../../../Icon/Layers/GridLayer.svg';
import { ReactComponent as Layers_RandomLayer } from '../../../Icon/Layers/RandomLayer.svg';
import { ReactComponent as Layers_CustomLayer } from '../../../Icon/Layers/CustomLayer.svg';
import { ReactComponent as Layers_ProteinLayer } from '../../../Icon/Layers/ProteinLayer.svg';
import { ReactComponent as Layers_SeedingLayer } from '../../../Icon/Layers/SeedingLayer.svg';
import { ReactComponent as Optimize } from '../../../Icon/Optimize.svg';
import { ReactComponent as Import } from '../../../Icon/Import.svg';
import { ReactComponent as Design } from '../../../Icon/Design.svg';
import { ReactComponent as Layers } from '../../../Icon/Layers.svg';
import { ReactComponent as FindDrop } from '../../../Icon/FindDrop.svg';
import { ReactComponent as DisableImage } from '../../../Icon/DisableImage.svg';
import { ReactComponent as CreateInspection } from '../../../Icon/CreateInspection.svg';
import { ReactComponent as DeleteInspection } from '../../../Icon/DeleteInspection.svg';
import { ReactComponent as AddImage } from '../../../Icon/AddImage.svg';
import { ReactComponent as Navigator } from '../../../Icon/Navigator.svg';
import { ReactComponent as Scores } from '../../../Icon/Scores.svg';
import { ReactComponent as AddSeed } from '../../../Icon/AddSeed.svg';
import { ReactComponent as Harvest } from '../../../Icon/Harvest.svg';
import { ReactComponent as Focus } from '../../../Icon/Focus.svg';
import { ReactComponent as ThumbnailNavigator } from '../../../Icon/ThumbnailNavigator.svg';
import { ReactComponent as CompositeNavigator } from '../../../Icon/CompositeNavigator.svg';
import { ReactComponent as CompareMode } from '../../../Icon/CompareMode.svg';
import { ReactComponent as CompareGrid } from '../../../Icon/CompareGrid.svg';
import { ReactComponent as CompareRow } from '../../../Icon/CompareRow.svg';
import { ReactComponent as PlateInfo } from '../../../Icon/PlateInfo.svg';
import { ReactComponent as Reload } from '../../../Icon/Reload.svg';
import { ReactComponent as Undo } from '../../../Icon/Undo.svg';
import { ReactComponent as Redo } from '../../../Icon/Redo.svg';
import { ReactComponent as IngredientTubes } from '../../../Icon/IngredientTubes.svg';
import { ReactComponent as ExportPOI } from '../../../Icon/ExportPOI.svg';
import { ReactComponent as Annotate } from '../../../Icon/Annotate.svg';
import { ReactComponent as POI } from '../../../Icon/POI.svg';
import { ReactComponent as ROI } from '../../../Icon/ROI.svg';
import { ReactComponent as Ruler } from '../../../Icon/Ruler.svg';
import { ReactComponent as Scribble } from '../../../Icon/Scribble.svg';
import { ReactComponent as ScoresColor } from '../../../Icon/ScoresColor.svg';
import { ReactComponent as License } from '../../../Icon/License.svg';
import { ReactComponent as UserSetup } from '../../../Icon/UserSetup.svg';
import { ReactComponent as AddLayer } from '../../../Icon/AddLayer.svg';
import { ReactComponent as EyeView } from '../../../Icon/EyeView.svg';
import { ReactComponent as EyeViewClose } from '../../../Icon/EyeViewClose.svg';
import { ReactComponent as ColorPicker } from '../../../Icon/ColorPicker.svg';
import { ReactComponent as DisputeScoreIcon } from '../../../Icon/DisputeScoreIcon.svg';
import { ReactComponent as BackArrow } from '../../../Icon/BackArrow.svg';
import { ReactComponent as BatchloadExperimentReport } from '../../../Icon/BatchloadExperimentReport.svg';
import { ReactComponent as PrintBatchLoadExpBarcode } from '../../../Icon/PrintBatchLoadExpBarcode.svg';
import { ReactComponent as Help } from '../../../Icon/Help.svg';
import { ReactComponent as Well } from '../../../Icon/Well.svg';
import { ReactComponent as Compare } from '../../../Icon/Compare.svg';
import { ReactComponent as Canvas } from '../../../Icon/Canvas.svg';
import { ReactComponent as ExperimentInfo } from '../../../Icon/ExperimentInfo.svg';
import { ReactComponent as DisableImageRed } from '../../../Icon/DisableImageRed.svg';
import { ReactComponent as TuningOverride } from '../../../Icon/TuningOverride.svg';
import { ReactComponent as RMFlowBanner } from '../../../Icon/RMFlowBanner.svg';
import { ReactComponent as SynchrotronTrip } from '../../../Icon/SynchrotronTrip.svg';
import { ReactComponent as Harvesting } from '../../../Icon/Harvesting.svg';
import { ReactComponent as NewHarvest } from '../../../Icon/NewHarvest.svg';
import { ReactComponent as PasteCryoprotectant } from '../../../Icon/PasteCryoprotectant.svg';
import { ReactComponent as PasteSoaking } from '../../../Icon/PasteSoaking.svg';
import { ReactComponent as AssignCrystal } from '../../../Icon/AssignCrystal.svg';
import { ReactComponent as CreateTrip } from '../../../Icon/CreateTrip.svg';
import { ReactComponent as CrystalDefinition } from '../../../Icon/CrystalDefinition.svg';
import { ReactComponent as UnassignCrystal } from '../../../Icon/UnassignCrystal.svg';
import { ReactComponent as Setup_ExclamationTriangle } from '../../../Icon/Setup/ExclamationTriangle.svg';
import { ReactComponent as Setup_Success } from '../../../Icon/Setup/Success.svg';
import { ReactComponent as Setup_Polygon } from '../../../Icon/Setup/Polygon.svg';
import { ReactComponent as Filter } from '../../../Icon/Filter.svg';
import { ReactComponent as Trash } from '../../../Icon/Trash.svg';
import { ReactComponent as SortDescending } from '../../../Icon/SortDescending.svg';
import { ReactComponent as OR } from '../../../Icon/OR.svg';
import { ReactComponent as AND } from '../../../Icon/AND.svg';
import { ReactComponent as New } from '../../../Icon/New.svg';
import { ReactComponent as Apply } from '../../../Icon/Apply.svg';
import { ReactComponent as LiquidClassUnion } from '../../../Icon/LiquidClassUnion.svg';
import { ReactComponent as MergeIngredients } from '../../../Icon/MergeIngredients.svg';
import { ReactComponent as Vendor } from '../../../Icon/Vendor.svg';
import { ReactComponent as AddIngredient } from '../../../Icon/AddIngredient.svg';
import { ReactComponent as ExcelFile } from '../../../Icon/ExcelFile.svg';
import { ReactComponent as DocFile } from '../../../Icon/docFile.svg';
import { ReactComponent as XMLFile } from '../../../Icon/XMLFile.svg';
import { ReactComponent as TextFile } from '../../../Icon/TextFile.svg';
import { ReactComponent as Error } from '../../../Icon/Error.svg';
import { ReactComponent as Union } from '../../../Icon/Union.svg';
import { ReactComponent as SynchrotronTrip_OpenCrystal } from '../../../Icon/SynchrotronTrip/OpenCrystal.svg';
import { ReactComponent as SynchrotronTrip_UnassignCrystalActive } from '../../../Icon/SynchrotronTrip/UnassignCrystalActive.svg';
import { ReactComponent as LockDrawing } from '../../../Icon/LockDrawing.svg';
import { ReactComponent as ImportSummary } from '../../../Icon/ImportSummary.svg';
import { ReactComponent as SPINE } from '../../../Icon/SPINE.svg';
import { ReactComponent as Uni } from '../../../Icon/Uni.svg';
import { ReactComponent as ACTOR } from '../../../Icon/ACTOR.svg';
import { ReactComponent as SSLR } from '../../../Icon/SSLR.svg';
import { ReactComponent as ALS } from '../../../Icon/ALS.svg';
import { ReactComponent as Settings_GlobalPreferences } from '../../../Icon/Settings/GlobalPreferences.svg';
import { ReactComponent as Settings_AdminSetup } from '../../../Icon/Settings/AdminSetup.svg';
import { ReactComponent as Support } from '../../../Icon/Support.svg';
import { ReactComponent as AutoScoreThreshold } from '../../../Icon/AutoScoreThreshold.svg';
import { ReactComponent as SynchrotronTripv4_Close } from '../../../Icon/SynchrotronTripv4_Close.svg';
import { ReactComponent as SynchrotronTripv4_Open } from '../../../Icon/SynchrotronTripv4_Open.svg';
import { ReactComponent as Setup_MergeStocks } from '../../../Icon/Setup/MergeStocks.svg';
import { ReactComponent as Preferences_CanvasPref } from '../../../Icon/Preferences/CanvasPref.svg';
import { ReactComponent as Preferences_DropPref } from '../../../Icon/Preferences/DropPref.svg';
import { ReactComponent as Preferences_ExperimentPref } from '../../../Icon/Preferences/ExperimentPref.svg';
import { ReactComponent as Preferences_MiscPref } from '../../../Icon/Preferences/MiscPref.svg';
import { ReactComponent as Preferences_PlatePref } from '../../../Icon/Preferences/PlatePref.svg';
import { ReactComponent as Preferences_ProjectPref } from '../../../Icon/Preferences/ProjectPref.svg';
import { ReactComponent as Preferences_ScoringPref } from '../../../Icon/Preferences/ScoringPref.svg';
import { ReactComponent as Preferences_TreeExplorerPref } from '../../../Icon/Preferences/TreeExplorerPref.svg';
import { ReactComponent as Table } from '../../../Icon/Table.svg';
import { ReactComponent as SlideShow } from '../../../Icon/slideShow.svg';
import { ReactComponent as SkipBackward } from '../../../Icon/SkipBackward.svg';
import { ReactComponent as SkipForward } from '../../../Icon/SkipForward.svg';
import { ReactComponent as Play } from '../../../Icon/Play.svg';
import { ReactComponent as Pause } from '../../../Icon/Pause.svg';
import { ReactComponent as TraverseByColumn } from '../../../Icon/TraverseByColumn.svg';
import { ReactComponent as TraverseByRow } from '../../../Icon/TraverseByRow.svg';
import { ReactComponent as ImageTools } from '../../../Icon/ImageTools.svg';
import { ReactComponent as updateNewsLogo } from '../../../Icon/updateNewsLogo.svg';
import { ReactComponent as WebHelpLogo } from '../../../Icon/WebHelpLogo.svg';
import { ReactComponent as OpenLink } from '../../../Icon/OpenLink.svg';
import { ReactComponent as DesignRM } from '../../../Icon/DesignRM.svg';
import { ReactComponent as DesignRM_raw } from '../../../Icon/DesignRM_raw.svg';
import { ReactComponent as AnalyzeRM } from '../../../Icon/AnalyzeRM.svg';
import { ReactComponent as AnalyzeRM_raw } from '../../../Icon/AnalyzeRM_raw.svg';
import { ReactComponent as DispenseFormulator } from '../../../Icon/DispenseFormulator.svg';
import { ReactComponent as DispenseFormulator_raw } from '../../../Icon/DispenseFormulator_raw.svg';
import { ReactComponent as RISonic } from '../../../Icon/RISonic.svg';
import { ReactComponent as RISonic_raw } from '../../../Icon/RISonic_raw.svg';
import { ReactComponent as DispenseNT8 } from '../../../Icon/DispenseNT8.svg';
import { ReactComponent as DispenseNT8_raw } from '../../../Icon/DispenseNT8_raw.svg';
import { ReactComponent as ScoreRM } from '../../../Icon/ScoreRM.svg';
import { ReactComponent as ScoreRM_raw } from '../../../Icon/ScoreRM_raw.svg';
import { ReactComponent as CrystalRM } from '../../../Icon/CrystalRM.svg';
import { ReactComponent as CrystalRM_raw } from '../../../Icon/CrystalRM_raw.svg';
import { ReactComponent as Clear } from '../../../Icon/Clear.svg';
import { ReactComponent as SortAscending } from '../../../Icon/SortAscending.svg';
import { ReactComponent as ImageSettings } from '../../../Icon/ImageSettings.svg';
import { ReactComponent as DisabledImageBlack } from '../../../Icon/DisabledImageBlack.svg';
import { ReactComponent as Inspections } from '../../../Icon/Inspections.svg';
import { ReactComponent as ImagingSettings } from '../../../Icon/ImagingSettings.svg';
import { ReactComponent as Region } from '../../../Icon/Region.svg';
import { ReactComponent as Drop } from '../../../Icon/Drop.svg';
import { ReactComponent as Unpin } from '../../../Icon/Unpin.svg';
import { ReactComponent as ComingSoon } from '../../../Icon/ComingSoon.svg';
import { ReactComponent as StorageInfo } from '../../../Icon/StorageInfo.svg';
import { ReactComponent as Duplicate } from '../../../Icon/Duplicate.svg';
import { ReactComponent as EyeOpen } from '../../../Icon/EyeOpen.svg';
import { ReactComponent as EyeClosed } from '../../../Icon/EyeClosed.svg';
import { ReactComponent as Tag } from '../../../Icon/Tag.svg';
import { ReactComponent as ChevronDownCircle } from '../../../Icon/ChevronDownCircle.svg';
import { ReactComponent as RadioFilter } from '../../../Icon/RadioFilter.svg';
import { ReactComponent as ChecklistFilter } from '../../../Icon/ChecklistFilter.svg';
import { ReactComponent as BookmarkBlack } from '../../../Icon/BookmarkBlack.svg';
import { ReactComponent as BookmarkWhite } from '../../../Icon/BookmarkWhite.svg';
import { ReactComponent as ArrowRight } from '../../../Icon/ArrowRight.svg';
import { ReactComponent as ArrowLeft } from '../../../Icon/ArrowLeft.svg';
import { ReactComponent as Start } from '../../../Icon/Start.svg';
import { ReactComponent as Preview } from '../../../Icon/Preview.svg';
import { ReactComponent as Download } from '../../../Icon/Download.svg';
import { ReactComponent as Fragment_Fragment } from '../../../Icon/Fragment/Fragment.svg';
import { ReactComponent as ArrowUp } from '../../../Icon/ArrowUp.svg';
import { ReactComponent as Reset } from '../../../Icon/Reset.svg';
import { ReactComponent as Settings_OrphanImages } from '../../../Icon/Settings/OrphanImages.svg';
import { ReactComponent as SearchandFilterInfo } from '../../../Icon/SearchandFilterInfo.svg';
import { ReactComponent as SearchandFilterResult } from '../../../Icon/SearchandFilterResult.svg';
import { ReactComponent as SearchandFilterCanvas } from '../../../Icon/SearchandFilterCanvas.svg';
import { ReactComponent as CustomTable } from '../../../Icon/CustomTable.svg';
import { ReactComponent as SnFTools } from '../../../Icon/SnFTools.svg';
import { ReactComponent as PanelScore } from '../../../Icon/PanelScore.svg';
import { ReactComponent as Funnel } from '../../../Icon/Funnel.svg';
import { ReactComponent as FilterPanel_AddTag } from '../../../Icon/FilterPanel/AddTag.svg';
import { ReactComponent as AddPlus } from '../../../Icon/AddPlus.svg';
import { ReactComponent as Cancel } from '../../../Icon/Cancel.svg';
import { ReactComponent as Upload } from '../../../Icon/Upload.svg';
import { ReactComponent as SearchAndFilterIcon } from '../../../Icon/SearchAndFilterIcon.svg';
import { ReactComponent as SearchAnalysis } from '../../../Icon/SearchAndFilterIcon.svg';
import { ReactComponent as CrossRounded } from '../../../Icon/CrossRounded.svg';
import { ReactComponent as ImageManagementTask } from '../../../Icon/ImageManagementTask.svg';
import { ReactComponent as DropLocation } from '../../../Icon/DropLocation.svg';
import { ReactComponent as FragmentDownloadTemplate } from '../../../Icon/FragmentDownloadTemplate.svg';
import { ReactComponent as UserPreference } from '../../../Icon/UserPreference.svg';
import { ReactComponent as GroupPreference } from '../../../Icon/GroupPreference.svg';
import { ReactComponent as MarkAsNotSeen } from '../../../Icon/MarkAsNotSeen.svg';
import { ReactComponent as AnnotationIcon } from '../../../Icon/AnnotationIcon.svg';
import { ReactComponent as AnnotationCanvasIcon } from '../../../Icon/AnnotationCanvasIcon.svg';
import { ReactComponent as Reports_FRAPDataPoints } from '../../../Icon/Reports/FRAPDataPoints.svg';
import { ReactComponent as QuickAccess } from '../../../Icon/QuickAccess.svg';
import { ReactComponent as Screens } from '../../../Icon/Screens.svg';
import { ReactComponent as Searches } from '../../../Icon/Searches.svg';
import { ReactComponent as SynchTrip } from '../../../Icon/SynchTrip.svg';
import { ReactComponent as SynchTripResult } from '../../../Icon/SynchTripResult.svg';
import { ReactComponent as SynchTripCrystals } from '../../../Icon/SynchTripCrystals.svg';
import { ReactComponent as CrystalTrack } from '../../../Icon/CrystalTrack.svg';
import { ReactComponent as Warning } from '../../../Icons/Warning.svg';
import { ReactComponent as Favourite } from '../../../Icons/Favourite.svg';
import { ReactComponent as ViewOTP } from '../../../Icons/ViewOTP.svg';
import { ReactComponent as ResetPassword } from '../../../Icons/ResetPassword.svg';
import { ReactComponent as Fragment_Add } from '../../../Icon/Fragment/Add.svg';
import { ReactComponent as Fragment_Delete } from '../../../Icon/Fragment/Delete.svg';
import { ReactComponent as SetDefaultQuota } from '../../../Icon/SetDefaultQuota.svg';
import { ReactComponent as Tree_Experiment_Hits } from '../../../Icon/Tree/Experiment_Hits.svg';
import { ReactComponent as Tree_Experiment_Expired } from '../../../Icon/Tree/Experiment_Expired.svg';
import { ReactComponent as Tree_Experiment_Expired_Hits } from '../../../Icon/Tree/Experiment_Expired_Hits.svg';
import { ReactComponent as TopImagesIcon } from '../../../Icon/TopImages.svg';
import { ReactComponent as SendImage } from '../../../Icons/Sidebar/SendImage.svg';
import { ReactComponent as DisputeScore } from '../../../Icons/Sidebar/DisputeScore.svg';
import { ReactComponent as ImageIcon } from '../../../Icon/ImageIcon.svg';
import { ReactComponent as RecycleBin } from '../../../Icon/Tree/RecycleBin.svg';
import { ReactComponent as SendInspection } from '../../../Icon/SendInspection.svg';
import { ReactComponent as RefreshImage } from '../../../Icon/RefreshImage.svg';
import { ReactComponent as SaveChart } from '../../../Icon/SaveChart.svg';
import { ReactComponent as Graph } from '../../../Icon/Graph.svg';
import { ReactComponent as SyncZoom } from '../../../Icon/SyncZoom.svg';
import { ReactComponent as UnSyncZoom } from '../../../Icon/UnSyncZoom.svg';
import { ReactComponent as Explore } from '../../../Icons/Sidebar/Explore.svg';
import { ReactComponent as AddScreen } from '../../../Icons/AddScreen.svg';
import { ReactComponent as AddProtein } from '../../../Icons/AddProtein.svg';
import { ReactComponent as PrintExperimentInfo } from '../../../Icon/PrintExperimentInfo.svg';
import { ReactComponent as NoResult } from '../../../Icon/NoResult.svg';
import { ReactComponent as DownloadLog } from '../../../Icon/DownloadLog.svg';
import { ReactComponent as CanvasMap } from '../../../Icon/CanvasMap.svg';
import { ReactComponent as FitToPlate } from '../../../Icon/FitToPlate.svg';

export type RMSvgIconNames =
  | 'Add'
  | 'Copy'
  | 'Cut'
  | 'Delete'
  | 'Edit'
  | 'Paste'
  | 'Print'
  | 'ThreeDotMenu'
  | 'ListView'
  | 'ContentView'
  | 'ThumbnailView'
  | 'DetailView'
  | 'FolderOpen'
  | 'Folder'
  | 'AccessRight'
  | 'HitsReport'
  | 'Marco'
  | 'Analyze'
  | 'Unlock'
  | 'Pin'
  | 'Info'
  | 'ArrowDown'
  | 'Ascending'
  | 'Descending'
  | 'Remove'
  | 'Settings'
  | 'Refresh'
  | 'Globe'
  | 'Reagents'
  | 'Camera'
  | 'xtal'
  | 'Dispense'
  | 'Crystals'
  | 'Plate'
  | 'crystaltracking'
  | 'Protein'
  | 'Seed'
  | 'Experiment'
  | 'Screen'
  | 'Project'
  | 'Projects'
  | 'ProjectsFolder'
  | 'ConvertToScreen'
  | 'ImageNow'
  | 'FragmentScreen'
  | 'ExperimentReport'
  | 'Dispensed'
  | 'DispensedAlchemist'
  | 'Export'
  | 'RotateCanvas'
  | 'ScreenStockReport'
  | 'ProteinFormulation'
  | 'ProteinFormulation_Variants'
  | 'RMLogo'
  | 'checkMark'
  | 'CrystalsGrey'
  | 'OrderBy'
  | 'SeedAddIng'
  | 'Tuning'
  | 'Images'
  | 'ScoresBottomMenu'
  | 'SeedRemoveIng'
  | 'Wizard'
  | 'ScreenExpWizard'
  | 'BatchloadExperiment'
  | 'Search'
  | 'Tools'
  | 'Email'
  | 'Close'
  | 'BatchloadTask'
  | 'PrintBarcode'
  | 'IngredientInfo'
  | 'IngredientStocks'
  | 'ImageManage'
  | 'FilledArrowDown'
  | 'ImageNowCamera'
  | 'SaveImage'
  | 'Experiment_Designed'
  | 'Experiment_Dispensed'
  | 'Experiment_Imaged'
  | 'Experiment_CrystalHarvested'
  | 'DashboardHeader'
  | 'Integrated_Marco'
  | 'Integrated_PrintBarcode'
  | 'Integrated_Idle'
  | 'Integrated_Active'
  | 'Integrated_Offline'
  | 'Integrated_Device'
  | 'OpenTab'
  | 'Pointer'
  | 'Bold'
  | 'Italic'
  | 'Underline'
  | 'LineThrough'
  | 'MoveBack'
  | 'Lock'
  | 'EditExperiment'
  | 'Barcode'
  | 'Report'
  | 'DesignReport'
  | 'ExperimentReport'
  | 'ImageReport'
  | 'IngredientReport'
  | 'InstantDropReport'
  | 'ScoreReport'
  | 'SingleDropReport'
  | 'WellReport'
  | 'Save'
  | 'Discard'
  | 'GridLayer'
  | 'RandomLayer'
  | 'CustomLayer'
  | 'ProteinLayer'
  | 'SeedingLayer'
  | 'Optimize'
  | 'Import'
  | 'Design'
  | 'Layers'
  | 'FindDrop'
  | 'DisableImage'
  | 'CreateInspection'
  | 'DeleteInspection'
  | 'AddImage'
  | 'Navigator'
  | 'Scores'
  | 'AddSeed'
  | 'Harvest'
  | 'Focus'
  | 'ThumbnailNavigator'
  | 'CompositeNavigator'
  | 'CompareMode'
  | 'CompareGrid'
  | 'CompareRow'
  | 'PlateInfo'
  | 'Reload'
  | 'Undo'
  | 'Redo'
  | 'IngredientTubes'
  | 'ExportPOI'
  | 'Annotate'
  | 'POI'
  | 'ROI'
  | 'Ruler'
  | 'Scribble'
  | 'ScoresColor'
  | 'License'
  | 'UserSetup'
  | 'AddLayer'
  | 'EyeView'
  | 'EyeViewClose'
  | 'ColorPicker'
  | 'DisputeScoreIcon'
  | 'BackArrow'
  | 'BatchloadExperimentReport'
  | 'PrintBatchLoadExpBarcode'
  | 'Help'
  | 'Well'
  | 'Compare'
  | 'Canvas'
  | 'ExperimentInfo'
  | 'DisableImageRed'
  | 'TuningOverride'
  | 'RMFlowBanner'
  | 'SynchrotronTrip'
  | 'Harvesting'
  | 'NewHarvest'
  | 'PasteCryoprotectant'
  | 'PasteSoaking'
  | 'AssignCrystal'
  | 'CreateTrip'
  | 'CrystalDefinition'
  | 'UnassignCrystal'
  | 'ExclamationTriangle'
  | 'Success'
  | 'Polygon'
  | 'Filter'
  | 'Trash'
  | 'SortDescending'
  | 'OR'
  | 'AND'
  | 'New'
  | 'Remove'
  | 'Apply'
  | 'LiquidClassUnion'
  | 'MergeIngredients'
  | 'Vendor'
  | 'AddIngredient'
  | 'ExcelFile'
  | 'DocFile'
  | 'XMLFile'
  | 'TextFile'
  | 'Error'
  | 'Error'
  | 'Union'
  | 'AddIngredient'
  | 'OpenCrystal'
  | 'UnassignCrystalActive'
  | 'LockDrawing'
  | 'ImportSummary'
  | 'SPINE'
  | 'Uni'
  | 'ACTOR'
  | 'SSLR'
  | 'ALS'
  | 'GlobalPreferences'
  | 'AdminSetup'
  | 'Support'
  | 'AutoScoreThreshold'
  | 'SynchrotronTripv4_Close'
  | 'SynchrotronTripv4_Open'
  | 'MergeStocks'
  | 'CanvasPref'
  | 'DropPref'
  | 'ExperimentPref'
  | 'MiscPref'
  | 'PlatePref'
  | 'ProjectPref'
  | 'ScoringPref'
  | 'TreeExplorerPref'
  | 'Table'
  | 'SlideShow'
  | 'SkipBackward'
  | 'SkipForward'
  | 'Play'
  | 'Pause'
  | 'TraverseByColumn'
  | 'TraverseByRow'
  | 'ImageTools'
  | 'updateNewsLogo'
  | 'WebHelpLogo'
  | 'OpenLink'
  | 'DesignRM'
  | 'DesignRM_raw'
  | 'AnalyzeRM'
  | 'AnalyzeRM_raw'
  | 'DispenseFormulator'
  | 'DispenseFormulator_raw'
  | 'RISonic'
  | 'RISonic_raw'
  | 'DispenseNT8'
  | 'DispenseNT8_raw'
  | 'ScoreRM'
  | 'ScoreRM_raw'
  | 'CrystalRM'
  | 'CrystalRM_raw'
  | 'Clear'
  | 'SortAscending'
  | 'ImageSettings'
  | 'DisabledImageBlack'
  | 'Inspections'
  | 'ImagingSettings'
  | 'Region'
  | 'Drop'
  | 'Unpin'
  | 'ComingSoon'
  | 'StorageInfo'
  | 'Duplicate'
  | 'EyeOpen'
  | 'EyeClosed'
  | 'Tag'
  | 'ChevronDownCircle'
  | 'RadioFilter'
  | 'ChecklistFilter'
  | 'BookmarkBlack'
  | 'BookmarkWhite'
  | 'ArrowRight'
  | 'ArrowLeft'
  | 'Start'
  | 'Preview'
  | 'Download'
  | 'Fragment'
  | 'ArrowUp'
  | 'Reset'
  | 'OrphanImages'
  | 'SearchandFilterInfo'
  | 'SearchandFilterResult'
  | 'SearchandFilterCanvas'
  | 'CustomTable'
  | 'SnFTools'
  | 'PanelScore'
  | 'Funnel'
  | 'AddTag'
  | 'AddPlus'
  | 'Cancel'
  | 'Upload'
  | 'SearchAndFilterIcon'
  | 'CrossRounded'
  | 'ImageManagementTask'
  | 'DropLocation'
  | 'FragmentDownloadTemplate'
  | 'UserPreference'
  | 'GroupPreference'
  | 'MarkAsNotSeen'
  | 'AnnotationIcon'
  | 'AnnotationCanvasIcon'
  | 'FRAPDataPoints'
  | 'DragError'
  | 'MultipleFiles'
  | 'Favourite'
  | 'ViewOTP'
  | 'ResetPassword'
  | 'Warning'
  | 'Fragment_Delete'
  | 'Fragment_Add'
  | 'SetDefaultQuota'
  | 'SearchAnalysis'
  | 'Experiment_Hits'
  | 'Experiment_Expired'
  | 'Experiment_Expired_Hits'
  | 'TopImagesIcon'
  | 'DisputeScore'
  | 'SendImage'
  | 'ImageIcon'
  | 'SendInspection'
  | 'RefreshImage'
  | 'SaveChart'
  | 'Graph'
  | 'SyncZoom'
  | 'UnSyncZoom'
  | 'Explore'
  | 'PrintExperimentInfo'
  | 'NoResult'
  | 'DownloadLog' 
  | 'CanvasMap'
  | 'FitToPlate';

const iconComponents = {
  FragmentDownloadTemplate,
  Add,
  Copy,
  Cut,
  Delete,
  Edit,
  Paste,
  Print,
  ThreeDotMenu,
  ListView,
  ContentView,
  ThumbnailView,
  DetailView,
  FolderOpen,
  Folder,
  AccessRight,
  HitsReport,
  Marco,
  Analyze,
  Unlock,
  Pin,
  Info,
  ArrowDown,
  Setup_Ascending,
  Setup_Descending,
  Remove,
  Setup_Add,
  Setup_Settings,
  Setup_Refresh,
  Setup_Globe,
  Setup_Reagents,
  Setup_Camera,
  Setup_xtal,
  Setup_Dispense,
  Crystals,
  Plate,
  Setup_Plate,
  crystaltracking,
  Protein,
  Seed,
  Experiment,
  Screen,
  Project,
  Projects,
  ProjectsFolder,
  ConvertToScreen,
  ImageNow,
  FragmentScreen,
  ExperimentReport,
  Dispensed,
  DispensedAlchemist,
  Export,
  RotateCanvas,
  ScreenStockReport,
  ProteinFormulation,
  ProteinFormulation_Variants,
  RMLogo,
  checkMark,
  CrystalsGrey,
  OrderBy,
  SeedAddIng,
  Tuning,
  Images,
  ScoresBottomMenu,
  SeedRemoveIng,
  Wizard,
  ScreenExpWizard,
  BatchloadExperiment,
  Search,
  Tools,
  Email,
  Close,
  BatchloadTask,
  PrintBarcode,
  IngredientInfo,
  IngredientStocks,
  ImageManage,
  FilledArrowDown,
  ImageNowCamera,
  SaveImage,
  Tree_Experiment_Designed,
  Tree_Experiment_Dispensed,
  Tree_Experiment_Imaged,
  Tree_Experiment_CrystalHarvested,
  DashboardHeader,
  Integrated_Marco,
  Integrated_PrintBarcode,
  Integrated_Idle,
  Integrated_Active,
  Integrated_Offline,
  Integrated_Device,
  OpenTab,
  Pointer,
  Bold,
  Italic,
  Underline,
  LineThrough,
  MoveBack,
  Lock,
  EditExperiment,
  Barcode,
  Reports_Report,
  Reports_DesignReport,
  Reports_ExperimentReport,
  Reports_ImageReport,
  Reports_IngredientReport,
  Reports_InstantDropReport,
  Reports_ScoreReport,
  Reports_SingleDropReport,
  Reports_WellReport,
  Save,
  Discard,
  Layers_GridLayer,
  Layers_RandomLayer,
  Layers_CustomLayer,
  Layers_ProteinLayer,
  Layers_SeedingLayer,
  Optimize,
  Import,
  Design,
  Layers,
  FindDrop,
  DisableImage,
  CreateInspection,
  DeleteInspection,
  AddImage,
  Navigator,
  Scores,
  AddSeed,
  Harvest,
  Focus,
  ThumbnailNavigator,
  CompositeNavigator,
  CompareMode,
  CompareGrid,
  CompareRow,
  PlateInfo,
  Reload,
  Undo,
  Redo,
  IngredientTubes,
  ExportPOI,
  Annotate,
  POI,
  ROI,
  Ruler,
  Scribble,
  ScoresColor,
  License,
  UserSetup,
  AddLayer,
  EyeView,
  EyeViewClose,
  ColorPicker,
  DisputeScoreIcon,
  BackArrow,
  BatchloadExperimentReport,
  PrintBatchLoadExpBarcode,
  Help,
  Well,
  Compare,
  Canvas,
  ExperimentInfo,
  DisableImageRed,
  TuningOverride,
  RMFlowBanner,
  SynchrotronTrip,
  Harvesting,
  NewHarvest,
  PasteCryoprotectant,
  PasteSoaking,
  AssignCrystal,
  CreateTrip,
  CrystalDefinition,
  UnassignCrystal,
  Setup_ExclamationTriangle,
  Setup_Success,
  Setup_Polygon,
  Filter,
  Trash,
  SortDescending,
  OR,
  AND,
  New,
  Setup_Remove,
  Apply,
  LiquidClassUnion,
  MergeIngredients,
  Vendor,
  AddIngredient,
  ExcelFile,
  DocFile,
  XMLFile,
  TextFile,
  Error,
  Union,
  SynchrotronTrip_OpenCrystal,
  SynchrotronTrip_UnassignCrystalActive,
  LockDrawing,
  ImportSummary,
  SPINE,
  Uni,
  ACTOR,
  SSLR,
  ALS,
  Settings_GlobalPreferences,
  Settings_AdminSetup,
  Support,
  AutoScoreThreshold,
  SynchrotronTripv4_Close,
  SynchrotronTripv4_Open,
  Setup_MergeStocks,
  Preferences_CanvasPref,
  Preferences_DropPref,
  Preferences_ExperimentPref,
  Preferences_MiscPref,
  Preferences_PlatePref,
  Preferences_ProjectPref,
  Preferences_ScoringPref,
  Preferences_TreeExplorerPref,
  Table,
  SlideShow,
  SkipBackward,
  SkipForward,
  Play,
  Pause,
  TraverseByColumn,
  TraverseByRow,
  ImageTools,
  updateNewsLogo,
  WebHelpLogo,
  OpenLink,
  DesignRM,
  DesignRM_raw,
  AnalyzeRM,
  AnalyzeRM_raw,
  DispenseFormulator,
  DispenseFormulator_raw,
  RISonic,
  RISonic_raw,
  DispenseNT8,
  DispenseNT8_raw,
  ScoreRM,
  ScoreRM_raw,
  CrystalRM,
  CrystalRM_raw,
  Clear,
  SortAscending,
  ImageSettings,
  DisabledImageBlack,
  Inspections,
  ImagingSettings,
  Region,
  Drop,
  Unpin,
  ComingSoon,
  StorageInfo,
  Duplicate,
  EyeOpen,
  EyeClosed,
  Tag,
  ChevronDownCircle,
  RadioFilter,
  ChecklistFilter,
  BookmarkBlack,
  BookmarkWhite,
  ArrowRight,
  ArrowLeft,
  Start,
  Preview,
  Download,
  Fragment_Fragment,
  ArrowUp,
  Reset,
  Settings_OrphanImages,
  SearchandFilterInfo,
  SearchandFilterResult,
  SearchandFilterCanvas,
  CustomTable,
  SnFTools,
  PanelScore,
  Funnel,
  FilterPanel_AddTag,
  AddPlus,
  Cancel,
  Upload,
  SearchAndFilterIcon,
  CrossRounded,
  ImageManagementTask,
  DropLocation,
  UserPreference,
  GroupPreference,
  MarkAsNotSeen,
  AnnotationIcon,
  AnnotationCanvasIcon,
  Reports_FRAPDataPoints,
  QuickAccess,
  Screens,
  Searches,
  SynchTrip,
  SynchTripResult,
  SynchTripCrystals,
  CrystalTrack,
  Warning,
  Favourite,
  ViewOTP,
  ResetPassword,
  Fragment_Delete,
  Fragment_Add,
  SetDefaultQuota,
  SearchAnalysis,
  Tree_Experiment_Hits,
  Tree_Experiment_Expired,
  Tree_Experiment_Expired_Hits,
  TopImagesIcon,
  SendImage,
  DisputeScore,
  ImageIcon,
  RecycleBin,
  SendInspection,
  RefreshImage,
  SaveChart,
  Graph,
  SyncZoom,
  UnSyncZoom,
  Explore,
  AddScreen,
  AddProtein,
  PrintExperimentInfo,
  NoResult,
  DownloadLog,
  CanvasMap,
  FitToPlate,
};
export interface RMSvgIconProps
  extends Omit<SVGProps, 'src' | 'height' | 'width' | 'fill'> {
  name: RMSvgIconNames;
  height?: number | string;
  width?: number | string;
  fill?: string;
  noFill?: boolean;
  subfolder?: string;
}

function RMSvgIcon(props: RMSvgIconProps) {
  const {
    name,
    height = '24px',
    width = '24px',
    fill = '#000000',
    noFill = false,
    subfolder = '',
    ...rest
  } = props;

  const IconComponent = iconComponents[`${(subfolder ? subfolder + '_' : '') + name}`];
  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      height={height}
      width={width}
      {...(!noFill && { fill: fill })}
      {...rest}
    />
  );
}

const svgImageIcons = {};

export function RMSvgIconImage(props: RMSvgIconProps) {
  if (!svgImageIcons[props.name]) {
    const svgString = renderToStaticMarkup(<RMSvgIcon {...props} />);
    const svg = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svg);
    const img = new Image();
    img.src = url;
    svgImageIcons[props.name] = img;
  }
  return svgImageIcons[props.name];
}

export default React.memo(RMSvgIcon);
